import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import PeopleIcon from "../../icons/PeopleIcon";

const menuItems = [
  {
    pageLabel: "Campaign",
    icon: <PeopleIcon />,
    path: "/campaign",
    topBarContent: "Campaign",
  },
];

const EngageSideMenu = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const isActive = (path: string) => {
    if (path === "/campaign") {
      return (
        location.pathname === path || location.pathname === "/campaign"
      );
    }
    return location.pathname === path;
  };

  return (
    <Box sx={{ height: "100%", width: "300px", background: "#FAE4D3" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          marginLeft: "32px",
          gap: 2,
          paddingTop: "32px",
          paddingBottom: "24px",
        }}
      >
        <Typography component="h3">
          {t("platform.SideMenu_engageTopDescription")}
        </Typography>
        <Typography
          component="div"
          sx={{ color: "#5D6E69", lineHeight: "24px" }}
        >
          {t("platform.SideMenu_engageTopContent")}
        </Typography>
      </Box>
      <Divider sx={{ borderColor: "#F3D2B8", marginBottom: "32px" }} />
      <MenuList sx={{ height: "100vh" }}>
        {menuItems.map(item => {
          const active = isActive(item.path);
          return (
            <MenuItem
              key={item.pageLabel}
              component={Link}
              to={item.path}
              selected={active}
              sx={{
                borderRadius: "8px",
                margin: "4px 16px",
                padding: "12px",
                color: "black",
                "& .MuiListItemIcon-root": {
                  color: "black",
                },
                "&.Mui-selected": {
                  backgroundColor: "#E87722",
                  color: "white",
                  fontWeight: 700,
                  "& .MuiListItemIcon-root": {
                    color: "white",
                  },
                  "&:hover": {
                    backgroundColor: "#E87722",
                  },
                },
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText>{item.pageLabel}</ListItemText>
            </MenuItem>
          );
        })}
      </MenuList>
    </Box>
  );
};

export default EngageSideMenu;
